var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
      },
      [_c("ShippingEligibilityInfo", { ref: "eligibility" })],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "choose-one-off flex flex-auto flex-col",
      },
      [
        _c("div", { staticClass: "title" }, [
          _vm._v("\n      Choose the one-off item\n    "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "description" }, [
          _vm._v(
            "\n      Please search and select the item you would like to process as one-off.\n    "
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("el-input", {
              staticClass: "one_off_search_box",
              attrs: { type: "text", placeholder: "Search", clearable: "" },
              model: {
                value: _vm.searchedValue,
                callback: function ($$v) {
                  _vm.searchedValue = $$v
                },
                expression: "searchedValue",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", [
          _vm.noResultFound
            ? _c(
                "div",
                { staticStyle: { display: "flex", padding: "16px 24px" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "error-msg",
                      staticStyle: {
                        width: "987px",
                        display: "flex",
                        "align-items": "center",
                        "justify-content": "center",
                        height: "84px",
                        border: "1px solid #DEE5EC",
                        color: "#81919F",
                        "font-feature-settings": "'clig' off, 'liga' off",
                      },
                    },
                    [
                      _vm._v(
                        "\n          No devices matching your search request found. Please try another one.\n        "
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              { staticStyle: { "overflow-y": "scroll", height: "600px" } },
              _vm._l(_vm.searchedItems, function (item) {
                return _c("div", _vm._b({ key: item.id }, "div", item, false), [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: item.ux_properties.loading,
                          expression: "item.ux_properties.loading",
                        },
                      ],
                      staticClass: "one-off-items-view",
                    },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "item-card",
                          class: { "highlighted-item-card": item.selected },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "flex-start",
                                  },
                                },
                                [
                                  _vm.productRestricted(item)
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            position: "absolute",
                                            right: "0",
                                          },
                                        },
                                        [
                                          _vm.expedited
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "expedited item",
                                                },
                                                [_vm._v("Expedited")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "shipping-restrictions-label",
                                            },
                                            [
                                              _vm._v(
                                                "Shipping Restrictions Apply"
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "item-image" },
                                    [
                                      _c("DeviceImage", {
                                        attrs: { device: item },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "item-content",
                                      staticStyle: { "margin-left": "8px" },
                                    },
                                    [
                                      _c("div", { staticClass: "item-name" }, [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(item.product.description) +
                                            " – Stock " +
                                            _vm._s(item.stock) +
                                            "\n                      "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "item-color" }, [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(item.color) +
                                            "\n                      "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      item.estimated_delivery
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "estimated-delivery",
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    item.estimated_delivery
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "one_off_radio_btn" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectedDevice,
                                      expression: "selectedDevice",
                                    },
                                  ],
                                  staticStyle: {
                                    "margin-right": "16px",
                                    "border-radius": "4px",
                                    width: "24px",
                                    height: "24px",
                                    "align-self": "center",
                                    "accent-color": "#1998D5",
                                  },
                                  attrs: {
                                    type: "radio",
                                    name: "options",
                                    disabled: _vm.productRestricted(item),
                                  },
                                  domProps: {
                                    value: item,
                                    checked: _vm._q(_vm.selectedDevice, item),
                                  },
                                  on: {
                                    change: [
                                      function ($event) {
                                        _vm.selectedDevice = item
                                      },
                                      function ($event) {
                                        return _vm.productChanged(item)
                                      },
                                    ],
                                  },
                                }),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              }),
              0
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }